import React from 'react';

const BiasIndicator = ({ biasData }) => {
    if (!biasData) return null;
    
    const { averageBiasScore, overallCategory } = biasData;
    
    const sliderPosition = ((averageBiasScore + 10) / 20) * 100;
    
    let sliderColor;
    switch (overallCategory) {
        case 'far-left':
            sliderColor = '#3300CC';
            break;
        case 'left-leaning':
            sliderColor = '#3366FF';
            break;
        case 'slightly-left':
            sliderColor = '#66B2FF';
            break;
        case 'neutral':
            sliderColor = '#888888';
            break;
        case 'slightly-right':
            sliderColor = '#FFB266';
            break;
        case 'right-leaning':
            sliderColor = '#FF6633';
            break;
        case 'far-right':
            sliderColor = '#CC3300';
            break;
        default:
            sliderColor = '#888888';
    }

    return (
        <div className="bias-indicator">
            <h5>Source Bias Analysis</h5>
            <div className="bias-meter-container">
                <div className="bias-labels">
                    <span>Left</span>
                    <span>Neutral</span>
                    <span>Right</span>
                </div>
                <div className="bias-meter">
                    <div 
                        className="bias-marker"
                        style={{ 
                            left: `${sliderPosition}%`,
                            backgroundColor: sliderColor
                        }}
                    />
                </div>
                <div className="bias-category">
                    {overallCategory.charAt(0).toUpperCase() + overallCategory.slice(1)}
                </div>
            </div>
        </div>
    );
};

export default BiasIndicator;